import { render, staticRenderFns } from "./Discover.vue?vue&type=template&id=5d9e8c05"
import script from "./Discover.vue?vue&type=script&lang=ts"
export * from "./Discover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports